/**
 * The audio level threshold to be considered an active speaker. Values
 * represent an amplitude that range from 0 to 32767 (16-bit integer). Set based
 * on experimentation.
 *
 * https://twilio.github.io/twilio-video-ios/docs/latest/Classes/TVIRemoteAudioTrackStats.html#//api/name/audioLevel
 */
export const ACTIVE_SPEAKER_THRESHOLD = 1000;
